import React, { useState, useEffect } from "react";
// import "./Button.css";
import styled from "styled-components";

const Styled = styled.button`
  font-family:
    proxima-nova,
    -apple-system,
    BlinkMacSystemFont,
    "Segoe UI",
    "Roboto",
    "Oxygen",
    "Ubuntu",
    "Cantarell",
    "Fira Sans",
    "Droid Sans",
    "Helvetica Neue",
    sans-serif;
  align-items: center;
  background-color: transparent;
  border: solid 1px #bbb;
  padding: 0.6rem 0.75rem;
  border-radius: 0.2rem;
  cursor: pointer;
  outline: none;
  font-size: 1em;
  color: #000;
  transition:
    border-color 0.2s,
    background-color 0.2s,
    color 0.2s;
  line-height: 1.6rem;
`;

const Button = (props) => {
  const [state, setState] = useState();

  let styles = {
    submit: {
      backgroundColor: "#3393c3",
      color: "#fff",
      border: "solid 1px #006699",
    },
  };

  let classes = ["ui-button"];
  if (props.type) {
    switch (props.type) {
      case "create":
        classes.push("ui-button-create");
        break;
    }
  }

  return <Styled {...props}>{props.children}</Styled>;
};
export default Button;
